<template>
  <div class="visits">
    <h2 class="profile__header">{{ $t('nav.recordsOld') }}</h2>
    <div class="row">
      <router-view></router-view>
    </div>
  </div>
</template>

<script>
export default {
  name: 'visits-past',
}
</script>
